import React from 'react';
import { Link } from 'react-router-dom';
import { FaTachometerAlt, FaBusinessTime, FaBook, FaMoneyBillWave } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

const Sidebar = ({ activeLink, handleLinkClick, signOutUser }) => {
  return (
    <div  className="d-none d-md-flex flex-column p-3" style={{ width: '250px', height: '88vh', backgroundColor: '#343a40', color: '#fff', display: 'flex', flexDirection: 'column', padding: '20px' }}>
      <Link
        style={{
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          backgroundColor: activeLink === 'dashboard' ? '#495057' : 'transparent',
          color: activeLink === 'dashboard' ? '#ffc107' : '#fff',
          fontWeight: activeLink === 'dashboard' ? 'bold' : 'normal',
          textDecoration: 'none',
          marginBottom: '10px',
        }}
        to="/home"
        onClick={() => handleLinkClick('dashboard')}
      >
        <FaTachometerAlt size={20} />
        <span>Dashboard</span>
      </Link>
      <Link
        style={{
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          backgroundColor: activeLink === 'businessInfo' ? '#495057' : 'transparent',
          color: activeLink === 'businessInfo' ? '#ffc107' : '#fff',
          fontWeight: activeLink === 'businessInfo' ? 'bold' : 'normal',
          textDecoration: 'none',
          marginBottom: '10px',
        }}
        to="/businessInfo"
        onClick={() => handleLinkClick('businessInfo')}
      >
        <FaBusinessTime size={20} />
        <span>Business Info</span>
      </Link>
      <Link
        style={{
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          backgroundColor: activeLink === 'bookings' ? '#495057' : 'transparent',
          color: activeLink === 'bookings' ? '#ffc107' : '#fff',
          fontWeight: activeLink === 'bookings' ? 'bold' : 'normal',
          textDecoration: 'none',
          marginBottom: '10px',
        }}
        to="/bookings"
        onClick={() => handleLinkClick('bookings')}
      >
        <FaBook size={20} />
        <span>Bookings</span>
      </Link>
      <Link
        style={{
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          backgroundColor: activeLink === 'withdraw' ? '#495057' : 'transparent',
          color: activeLink === 'withdraw' ? '#ffc107' : '#fff',
          fontWeight: activeLink === 'withdraw' ? 'bold' : 'normal',
          textDecoration: 'none',
          marginBottom: '10px',
        }}
        to="/withdraw"
        onClick={() => handleLinkClick('withdraw')}
      >
        <FaMoneyBillWave size={20} />
        <span>Withdrawals</span>
      </Link>
      <Button variant="danger" onClick={signOutUser} style={{ marginTop: 'auto' }}>
        Sign Out
      </Button>
    </div>
  );
};

export default Sidebar;